import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  {label: 'Activity', value: 'ACTIVITY'},
  {label: 'Activity Date', value: 'ACTIVITY_DATE'},
  {label: 'Container', value: 'CONTAINER_NUMBER'},
  {label: 'Trailer', value: 'TRAILER_NUMBER'},
  {label: 'Chassis', value: 'CHASSIS_NUMBER'},
  {label: 'Chassis License #', value: 'CHASSIS_LICENSE_PLATE_NUMBER'},
  {label: 'Size', value: 'ASSET_SIZE'},
  {label: 'First Name (Driver)', value: 'DRIVER_FIRST_NAME'},
  {label: 'Last Name (Driver)', value: 'DRIVER_LAST_NAME'},
  {label: 'License (Driver)', value: 'DRIVER_LICENSE_NUMBER'},
  {label: 'Seal', value: 'SEAL_NUMBER'},
  {label: 'Type', value: 'ASSET_TYPE'},
  {label: 'Booking', value: 'ORDER_NUMBER'},
  {label: 'Location', value: 'LOCATION_NAME'},
  {label: 'Partner', value: 'SUPPLIER_NAME'},
  {label: 'Inventory', value: 'CURRENT_INVENTORY'},
] as const satisfies Array<{label: string, value: string}>;

export type BuyerInventoryActivitySortByType = typeof sortByFields[number]['value'];

export interface BuyerInventoryActivitySortParams extends SortParams {
  sortBy?: BuyerInventoryActivitySortByType;
  sortDir?: SortDirType
}